/**
 * List of possible Brands.
 */
export enum Brands {
  Athleta = "at",
  BananaRepublic = "br",
  BananaRepublicFactoryStore = "brfs",
  Gap = "gap",
  GapFactoryStore = "gapfs",
  HillCity = "hc",
  OldNavy = "on",
}
